/* eslint-disable */
// import Cookies from 'js-cookie'

const MemberSessionKey = 'Member-Session'
const XAuthTokenKey = 'Member-Token'
const XAuthAgentKey = 'Agent-Token'
const AgentSessionKey = 'Agent-Session'
const AuthorizationUsername = 'tejomurtiproject'
const AuthorizationPassword = 'aF7LDyx!h!wd$LyS:~@k@M9[vR}_wf{-'
const Authorization = 'Basic ' + btoa(AuthorizationUsername + ':' + AuthorizationPassword)
const ShowModalPromo = 'Modal-Promo'
const referralCode = 'Referral-Code'

export function setReferralCode(value) {
  return localStorage.setItem(referralCode, value)
}
export function removeReferralCode() {
  return localStorage.removeItem(referralCode)
}

export function getReferralCode() {
  return localStorage.getItem(referralCode)
}

export function setShowModalPromo(value) {
  return localStorage.setItem(ShowModalPromo, value)
}

export function removeShowModalPromo() {
  return localStorage.removeItem(ShowModalPromo)
}

export function getShowModalPromo() {
  return localStorage.getItem(ShowModalPromo)
}

export function getMemberSession() {
  return localStorage.getItem(MemberSessionKey)
}
export function setMemberSession(data) {
  return localStorage.setItem(MemberSessionKey, JSON.stringify(data))
}

export function removeMemberSession() {
  return localStorage.removeItem(MemberSessionKey)
}

export function getAuthBasic() {
  return Authorization;
}
export function getXAuthToken() {
  return localStorage.getItem(XAuthTokenKey)
}
export function setXAuthToken(token) {
  return localStorage.setItem(XAuthTokenKey, token)
}

export function removeXAuthToken() {
  return localStorage.removeItem(XAuthTokenKey)
}

export function getXAuthAgent() {
  return localStorage.getItem(XAuthAgentKey)
}
export function setXAuthAgent(token) {
  return localStorage.setItem(XAuthAgentKey, token)
}

export function removeXAuthAgent() {
  return localStorage.removeItem(XAuthAgentKey)
}


export function getAgentSession() {
  return localStorage.getItem(AgentSessionKey)
}
export function setAgentSession(data) {
  return localStorage.setItem(AgentSessionKey, JSON.stringify(data))
}

export function removeAgentSession() {
  return localStorage.removeItem(AgentSessionKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js